<template class="change-log">
	<div class="h-100 d-flex flex-column">

		<div class="row no-gutters mb-3 form-container nk-card">
			<div class="col-6 col-sm-3 mb-4 mb-sm-0">
				<nk-col-form-group :label="$t('search') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8, xs: 12 }">
					<nk-input :options="componentOptions.searchInput" v-model="searchTerm" :tabindex="101"></nk-input>
				</nk-col-form-group>
			</div>
			<div v-show="selectedDateRange && selectedDateRange.key == 'CustomRange'" class="col-6 col-sm-9 mb-4 mb-sm-0"></div>
			<div class="col-6 col-sm-3 order-1 order-sm-1 mb-4 mb-sm-0">
				<nk-col-form-group :label="$t('document.document-selector.date-range') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8, xs: 12 }">
					<nk-dropdown :options="componentOptions.dateRange" v-model="selectedDateRange" :tabindex="102" :data="dateRanges" ref="range"></nk-dropdown>
				</nk-col-form-group>
			</div>
			<div class="col-6 col-sm-3 order-3 order-sm-2 p-1 p-sm-0" v-show="selectedDateRange && selectedDateRange.key == 'CustomRange'">
				<nk-col-form-group :label="$t('reports.start-date') + ':'" :labelSizes="{ xs: 12, sm: 5 }" :dataSizes="{ xs: 12, sm: 7 }">
					<nk-date :options="componentOptions.date" v-model="startDate" :tabindex="103"></nk-date>
				</nk-col-form-group>
			</div>
			<div class="col-6 col-sm-3 order-4 order-sm-3 p-1 p-sm-0" v-if="selectedDateRange && selectedDateRange.key == 'CustomRange'">
				<nk-col-form-group :label="$t('reports.end-date') + ':'" :labelSizes="{ xs: 12, sm: 5 }" :dataSizes="{ xs: 12, sm: 7 }">
					<nk-date :options="componentOptions.date" v-model="endDate" :tabindex="104"></nk-date>
				</nk-col-form-group>
			</div>
			<div class="col-6 col-sm-3 text-center mt-4 mb-4 mt-sm-0 mb-sm-0 order-2 order-sm-4 change-log-btn-container">
				<nk-button :tabindex="104" class="" :options="componentOptions.btnLoad" @click="getChangeLogList"></nk-button>
			</div>
		</div>

		<div class="h-grow-lock nk-card">
			<ag-grid :options="componentOptions.tableOptions" :data="changeLogs" v-model="selectDetailRow" ref="changeLogsTable" tabindex="105" startup class=""></ag-grid>
		</div>
	</div>
</template>

<script>
	import ChangeLogDetails from '~/components/form/change-log/change-log-details.vue'
	import $sc from '~/plugins/shortcut.collection.js'
	import { mapGetters, mapActions } from 'vuex'
	import nkButton from "@/components/general/button"
	import { defineAsyncComponent, markRaw } from 'vue'
	import _ from 'lodash'

	export default {
		name: 'change-log',
		modal: {
			size: 'md',
			stateUID: 'change-log'
		},
		props: {
			options: Object
		},
		computed: {
			...mapGetters({
				changeLogsList: 'changelog/changelogs'
			}),
			entityId() {
				if (!this.settings.entityId) {
					return null
				}
				return this.settings.entityId
			},
		},
		data() {
			return {
				logComponent: null,
				searchTerm: '',
				changeLogs: [],
				selectedDateRange: null,
				dateRanges: null,
				selectDetailRow: null,
				startDate: null,
				endDate: null,
				logTypes: {
					'AccountLinkedFloatingCenters': defineAsyncComponent(() => import('@/components/form/link-to-center/link-to-center-log-details.vue')),
					'ChangeFloatingCenter': defineAsyncComponent(() => import('@/components/form/change-log/entities/document-account-floating-center-change.vue')),
					'ChangeAccount': defineAsyncComponent(() => import('@/components/form/change-log/entities/document-account-floating-center-change.vue')),
					'DocumentSorting': defineAsyncComponent(() => import('@/components/form/change-log/entities/document-sorting.vue')),
					'GeneralLedger': defineAsyncComponent(() => import('@/components/form/change-log/entities/general-ledger.vue')),
				},
				settings: {
					title: true,
					prefix: ''
				},
				componentOptions: {
					searchInput: {
						mode: 'string'
					},
					tableOptions: {
						id: this.$options.name,
						pagination: true,

						groupIncludeTotalFooter: false,
						enterToSelect: true,
						eowSelection: 'single',
						columnDefs: [
							{
								field: 'user',
								headerName: this.$t('change-log.table.user'),
								contentType: 'string',
								width: 80,
								align: 'center',
								headerClass: 'text-center',
								cellClass: 'text-center',
							},
							{
								field: 'entityType',
								headerName: this.$t('change-log.table.entityType'),
								contentType: 'enum',
								valueGetter: params => params.data.entityType && this.$t(`EntityTypes.${params.data.entityType.upperCaseFirstLetter()}`),
								valueFormatter: data => data.value,
								width: 80,
								headerClass: 'text-center',
								cellClass: 'text-center',
							},
							{
								field: 'operation',
								headerName: this.$t('change-log.table.operation'),
								contentType: 'enum',
								valueGetter: params => params.data.operation && this.$t(`change-log.operations.${params.data.operation.toLowerCase()}`),
								valueFormatter: data => data.value,
								width: 80,
								headerClass: 'text-center',
								cellClass: 'text-center',
							},
							{
								field: 'created',
								headerName: this.$t('change-log.table.date'),
								contentType: 'date',
								width: 100,
								headerClass: 'text-center',
								cellClass: 'text-center',
							},
							{
								field: 'created',
								headerName: this.$t('change-log.table.time'),
								contentType: 'string',
								valueFormatter: date => {
									if (date.value == '0001-01-01T00:00:00') return ''
									let dt = date.value && new Date(date.value) || null
									return dt && `${dt.getHours().toString().padStart(2, '0')}:${dt.getMinutes().toString().padStart(2, '0')}:${dt.getSeconds().toString().padStart(2, '0')}`
								},
								width: 100,
								headerClass: 'text-center',
								cellClass: 'text-center',
							},
							{
								field: 'description',
								headerName: this.$t('change-log.table.description'),
								contentType: 'string',
								width: 150,
							},
							{
								field: 'json',
								headerName: this.$t('change-log.table.additional-information'),
								width: 100,
								minWidth: 100,
								cellClass: 'text-center',
								headerClass: ' text-center',
								filter: false,
								sortable: false,
								singleClickEdit: true,
								cellRenderer: nkButton,
								cellRendererParams: (data) => {
									return {
										options: {
											title: this.$t('change-log.buttons.additional-information'),
											isPrimary: true,
											icon: 'info-circle',
											style: 'width: 100px',
											visible: data.value && data.value != '[]',
											tooltipEnabled: false,
											hideTitle: false,
											agGridClickHandler: () => {
												this.showChangeLogDetails(data.data.id)

											},
										},
									}
								},
							}
						]

					},
					dateRange: {
						searchable: true,
						required: true,
						remoteSearch: false,
						placeholder: this.$t('select-it'),
						display: function (item) { return this.$t(item.group + '.' + item.key.toLowerCase()) },
						searchableFields: ['key']
					},
					date: {
						pickerEnabled: true,
					},
					btnLoad: {
						title: this.$t('load-report'),
						shortcut: $sc.find('search'),
						isPrimary: false,
						icon: '',
						handle: () => this.getChangeLogList
					}
				}
			}
		},
		mounted() {
			this.settings = _.merge(this.settings, this.options)
			this.prepareWindow(this.settings.entityTitle)
			this.getProperties()
			this.defer(() => this.$refs.range.$el.focus(), 100)
			this.getChangeLogList()
		},
		methods: {
			...mapActions({
				getChangelogs: 'changelog/fetchChangelogs'
			}),
			showChangeLogDetails(id) {
				let found = this.changeLogs.find(x => x.id === id)
				this.showModal({ component: this.logTypes[found.entityType] ? markRaw(this.logTypes[found.entityType]) : ChangeLogDetails, options: { items: JSON.parse(found.json), entityType: found.entityType, prefix: this.settings.prefix } })
					.then(res => { })
					.catch(err => { })
			},
			getChangeLogList() {
				const wait = this.$wait(this.$el)

				this.getChangelogs({ companyId: this.settings.companyId, userId: this.settings.userId, entityType: this.settings.entityType, entityId: this.settings.entityId, searchTerm: this.searchTerm, force: false, startDate: this.startDate, endDate: this.endDate, dateRange: this.selectedDateRange ? this.selectedDateRange.key : '' }).then(() => {
					this.changeLogs = this.changeLogsList
				}).finally(() => {
					wait.end()
				})
			},
			getProperties() {
				this.dateRanges = this.getPropertiesByGroup('DateRanges')
				this.selectedDateRange = (this.dateRanges || []).find(x => x.key === 'SevenDays')
			},
			applyFilter() {
				if (!this._debouncedSetQuickFilterValue) {
					this._debouncedSetQuickFilterValue = _.debounce(c => {
						this.$refs.changeLogsTable.setQuickFilterValue(c)
					}, 250)
				}
				this._debouncedSetQuickFilterValue(this.searchTerm)
			}
		}
	}
</script>

<style>
	.change-log-title {
		text-align: center;
		font-size: 1.2rem;
		margin: auto;
		background-color: #fffef6;
		margin: -10px -10px 20px -10px;
		border-bottom: 1px dashed #ffc400;
		color: #a27c00;
		padding: 10px;
	}

	@media screen and (max-width: 768px) {
		.change-log-btn-container {
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.change-log-btn-container>button {
			width: 70px;
			height: 26px;
		}
	}
</style>
